module.exports = __webpack_public_path__ + "img/E155.1f971a0b.svg";